import * as React from 'react'
import Stack from '@mui/material/Stack'

import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'

import { CardChip } from './atoms'
import type { PopoverState } from './typing'

export function AppointmentsButton(props: PopoverState & { entityId: number }) {
  const { open, onOpen, entityId } = props

  const icon = open ? <KeyboardArrowUp /> : <KeyboardArrowDown />

  return (
    <CardChip
      clickable
      size="small"
      onClick={onOpen}
      variant="outlined"
      data-test-id={`appointments-button-${entityId}`}
      label={
        <Stack direction="row" alignItems="center">
          Next Scheduled Appointment
          {icon}
        </Stack>
      }
    />
  )
}
